<template>
  <nx-fullscreen-dialog
      :active="active"
      :title="$t('message.block.youtube')"
      @dismiss="dismiss">

    <template slot="toolbar-items">
      <v-btn
          :disabled="!isValid"
          @click="insertBlot"
          color="accent"
          flat
          v-html="buttonTitle"
      ></v-btn>
    </template>

    <v-container pb-3 fluid>
      <v-layout>
        <v-flex class="md6 offset-md3 sm10 offset-sm1 pt-4">
          <v-layout row wrap>

            <v-flex class="xs12">
              <h2 class="nx-block-headline" v-html="formTitle"></h2>

              <v-text-field
                  :error-messages="error"
                  :label="$t('message.block.form.youtube')"
                  :placeholder="$t('message.block.form.youtubePlaceholder')"
                  autofocus
                  v-model="url"
              ></v-text-field>

              <div ref="preview" id="youtube-preview">
                <iframe
                    :src="`//www.youtube.com/embed/${data.videoId}?fs=0&rel=0`"
                    allowfullscreen
                    frameborder="0"
                    height="360"
                    v-if="isValid"
                    width="640"
                ></iframe>
              </div>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>


  </nx-fullscreen-dialog>
</template>


<script>
import isEmpty from 'lodash/isEmpty';
import DialogButton from './DialogButton';
import youtubeIdFromUrl from '@/utils/youtube-id-from-url';

/**
 * YoutubeButton Component
 *
 * Extend DialogButton component
 *
 */
export default {
  name: 'nx-youtube-button',
  extends: DialogButton,
  props: {
    embedVideoId: [String, Number],
  },
  data() {
    return {
      name: 'youtubeEmbed',
      data: {
        videoId: this.embedVideoId,
      },
      url: this.embedVideoId ? `https://www.youtube.com/watch?v=${this.embedVideoId}` : '',
    };
  },
  computed: {
    isValid() {
      return !isEmpty(this.data.videoId)
        && isEmpty(this.error);
    },
  },
  watch: {
    url(url) {
      const videoId = youtubeIdFromUrl(url);
      if (!videoId) {
        this.data.videoId = '';
        this.error = [this.$t('message.block.form.youtubeError')];
      } else {
        this.data.videoId = videoId;
        this.error = [];
      }
    },
  },
};
</script>

<style lang="stylus">
#youtube-preview {
  iframe {
    display: table;
    margin: auto;
  }
}
</style>
